import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { consulationService } from '../../services/api/consultation.service';
import { nomService } from '../../services/api/nom.service';
import { utils } from "../../services/helpers/utils";
import { ListDialog } from "../shared/listDialog";
import { ConsultationPatientInvestigations } from "./consultationPatientInvestigations";
import { alertService } from '../../services/helpers/alert.service';


export const ConsultationInvestigations = (props) => {
    const row = {
        idInvestigatie: null,
        idConsultatie: props.consultatie ? props.consultatie : 0,
        statusFinanciar: 0,
        idContract: null,
        idPreautorizare: null,
        idGrup: null,
        tipAplicare: null,
        procent: null,
        consumAmbulatoriu: null,
        consumGrup: null,
        valoare: null,
        detaliuReducere: "",
    
    }

    /* Investigatii */
    const [investigationList, setInvestigationList] = useState([]);
    const [defaults, setDefaults] = useState([])
    const [dropdown, setDropdown] = useState([])
    const [financiarDropdown, setFinanciarDropdown] = useState([]);
    const [financiarDefaults, setFinanciarDefaults] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [activeDialog, setActiveDialog] = useState(null);
    const [clickedIndex, setClickedIndex] = useState(null);
    

    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (props && props.consultatie) {
            //* Aduc lista de investigatii  */
            consulationService.getInvestigations({ consultation: props.consultatie })
                .then(response => {
                    if (response) {
                        setInvestigationList(response);
                        props.setInvestigatii(response);
                    }

                });
        }

        nomService.getFinancialStatus()
            .then(response => {
                if (response) {
                    setFinanciarDropdown(response);
                }
            });

    }, [props.render]);


    useEffect(() => {
        if (props.pacient != null && props.pacient != undefined &&
            props.locatie != null && props.locatie != undefined &&
            props.abonament != null && props.abonament != undefined &&
            props.tip != null && props.tip != undefined) {

            let params = {
                abonament: props.abonament,
                pacient: props.pacient,
                locatie: props.locatie,
                laborator: props.tip == 'Y' ? 1 : 0,
                data: props.data ?? new Date(),
                idConsultatie: props.idConsultatie,
                idMedicTrimitator: props.idMedicTrimitator,
                partener: props.partener,
                user: props.user,
                procentMajorare: props.procentMajorare ?? 0
            }
            /* Adug investigatii referitoare la lista de preturi */
            consulationService.getInvestigationsDropdown(params)
                .then(response => {
                    if (response) {
                        
                        if (Array.isArray(response) && response.length > 0) {
                            for (let i = 0; i < response.length; i++) {
                                response[i].id = response[i].investigatie;
                                response[i].text = response[i].denumire;
                            }

                            
                            setDropdown(response);
                        }
                    }
                   
                });
        }
    }, [props.pacient, props.locatie, props.abonament, props.tip, props.idMedicTrimitator, props.consultatie])


 

    useEffect(() => {
        if (investigationList.length > 0) {
            handleGetInvestigationDetails(investigationList);
        }
    }, [props.forceRecalcul, props.render]  );

    useEffect(() => {
        if (investigationList.length > 0) {
            let d = [];
            let newElements = [];
            for (var item in investigationList) {
                var el = utils.findObjectById(dropdown, investigationList[item].idInvestigatie)
                if (el) {
                    d.push(el);
                }
                else {
                    // Pentru diagnoticele care nu sunt active le aduc din baza si le adaug in dropdown
                    if (investigationList[item].idInvestigatie > 0) {
                        nomService.getInvestigationsById({ id: investigationList[item].idInvestigatie })
                            .then(response => {
                                if (response) {
                                    newElements.push(response);
                                    d.push(response);
                                }
                            });
                    }
                }
            }

            if (newElements.length > 0) {
                let newDropdown = [...dropdown]
                newDropdown.push(newElements);
                setDropdown(newDropdown);
            }


            setDefaults(d);
        }

    }, [investigationList, dropdown]);


    useEffect(() => {
        if (investigationList.length > 0 && financiarDropdown.length > 0) {
            var d = [];
            for (var item in investigationList) {
                var el = utils.findObjectById(financiarDropdown, (investigationList[item].statusFinanciar ?? 0))
                d.push(el);
            }
            setFinanciarDefaults(d);
        }
    }, [investigationList, financiarDropdown]);


    const [newInvestigation, setNewInvestigation] = useState( row );

    const handleChange = (event, index, field) => {

        

        const updatedInvestigatieList = [...investigationList];
        updatedInvestigatieList[index][field] = event.value?.id;

        // id_preautorizare nu e ales de utilizator, se preia din randul de dropdown.
        // Fara asta preautorizarea nu se consuma niciodata si ramane disponibila la infinit.
        if (field === "idInvestigatie") {
            updatedInvestigatieList[index]["idPreautorizare"] = event.value?.idPreautorizare ?? null;
        }

        handleGetInvestigationDetails(updatedInvestigatieList);
        props.setIsModified(true);

        

        setSearchTerm("");
    };

    const handleAddInvestigatie = () => {

        if (!props.locatie) {
            alertService.error("Selectati locatia!");
            return;
        }

        if (!props.idMedicTrimitator) {
            alertService.error("Selectati medicul trimitator!");
            return;
        }

        var newInvestigationRow = [...investigationList, newInvestigation];
        setNewInvestigation(row);
        setInvestigationList(newInvestigationRow);
        props.setInvestigatii(newInvestigationRow);
        props.setIsModified(true);
    };

    const handleGetInvestigationDetails = ( list ) => {
        let _tranzactii = []
        for (var item in list) {
            let investigatie = list[item].idInvestigatie;
            let valoare = dropdown.find(x => x.id == investigatie)?.valoare;
            _tranzactii.push({
                investigatie: investigatie,
                pret: valoare,
            });
        }
        

        let _consultatie = {
            idConsultatie: props.consultatie ?? 0,
            idPacient: props.pacient,
            data: props.data,
            laborator: props.tip == 'Y' ? 1 : 0,
            idMedicExtern: props.idMedicTrimitator,
            profileContracte: props.abonament,
            procentMajorare: props.procentMajorare,
        };
        
       


        consulationService.getPriceDetails({ consultatie: _consultatie, tranzactii : _tranzactii })
            .then(response => {
                if (response) {
                    let investigatii = [...list];
                    for (var item in investigatii) {
                        let investigatie = investigatii[item].idInvestigatie;
                        let elemDetails = response.find(x => x.idInvestigatie == investigatie);
                        if (elemDetails != null && elemDetails != undefined) {
                            investigatii[item]["idGrup"] = elemDetails.idGrup;
                            investigatii[item]["idContract"] = elemDetails.idContract;
                            investigatii[item]["tipAplicare"] = elemDetails.tipAplicare;
                            investigatii[item]["procent"] = elemDetails.organ;
                            investigatii[item]["consumAmbulatoriu"] = elemDetails.consumAmbulatoriu;
                            investigatii[item]["consumGrup"] = elemDetails.consumGrup;
                            investigatii[item]["comentariu"] = elemDetails.comentariu;
                            // Păstrăm detaliuReducere salvat sau folosim comentariu din API
                            investigatii[item]["detaliuReducere"] = list[item].detaliuReducere || elemDetails.comentariu;
                        }
                    }
                    setInvestigationList(investigatii);
                    props.setInvestigatii(investigatii);

                    if (props.forceRecalcul) {
                        // Odată ce calculul este complet
                        props.onDetailsCompleted();
                    }
                }
            })

    }

   

    const handleDeleteInvestigatie = (index) => {


        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi aceasta investigatie?"
            , () => {
                const updatedInvestigatieList = [...investigationList];
                updatedInvestigatieList.splice(index, 1);
                setInvestigationList(updatedInvestigatieList);
                props.setInvestigatii(updatedInvestigatieList);
                props.setIsModified(true);
                if (updatedInvestigatieList.length > 0) {
                    handleGetInvestigationDetails(updatedInvestigatieList);
                }
            }, () => { return; }
        );

       
    };

    /* Butonul de editare */
    const handleDialog = () => {
        setShowDialog(!showDialog);
    }

    const handleClick = (item) => {
        setClickedIndex(item);
        setActiveDialog("investigatii");
        setShowDialog(true);
    }

    const showInvestigatiiPacient = () => {
        setActiveDialog("investigatii-pacient");
        setShowDialog(true);
    }

    const handleReturn = (item) => {
        // Se actualizeaza lista de investigatii nu dropdownul!!!!
        let newlist = [...investigationList];
        newlist[clickedIndex].idInvestigatie = dropdown[item].id;
        newlist[clickedIndex].idPreautorizare = dropdown[item].idPreautorizare ?? null;
        setInvestigationList(newlist);
        props.setInvestigatii(newlist);
    }


    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);

    };


    const filtred = searchTerm ? dropdown.filter((item) => item.text.toLowerCase().includes(searchTerm.toLowerCase())): dropdown;

    /******************/

    return (
        <>
            <fieldset>
                <legend className="pb5">Investigatii <span className="red">*</span></legend>
                <table className="tbl tbladd mt5" data-name="lista_investigatii" width="100%">
                    <thead>
                        <tr>
                            <th width="365">Nume investigatie</th>
                            <th>Preautorizare</th>
                            <th>Financiar</th>
                            <th>Facturat</th>
                            <th>Status</th>
                            <th>Motiv respingere</th>
                            <th width="50">Editeaza</th>
                            <th width="50">Sterge</th>
                        </tr>
                    </thead>
                    <tbody>
                        {investigationList.map((investigatie, index) => (
                            <tr key={index}>
                                <td>

                                    <DropDownList
                                        data={filtred}
                                        filterable
                                        onFilterChange={handleFilterChange}
                                        name="idInvestigatie"
                                        textField="text"
                                        dataItemKey="id"
                                        value={defaults[index]}
                                        className="text w310 fl"

                                        onChange={(event) =>
                                            handleChange(event, index, "idInvestigatie")
                                        }
                                        disabled={props.statusFinalizare==1}
                                    />
                                    {
                                        investigatie.procent > 0 &&
                                        <div className="clear ml10 pt5"> {investigatie.procent == 100 && (investigatie.detaliuReducere || investigatie.comentariu || 'inclusa') ? (investigatie.detaliuReducere || investigatie.comentariu || 'inclusa') : investigatie.procent + "% reducere"}</div>
                                    }
                                </td>

                                <td> {investigatie.idPreautorizare ??""} </td>
                                <td> <DropDownList
                                    name="statusFinanciar"
                                    data={financiarDropdown}
                                    value={financiarDefaults[index]}
                                    textField="text"
                                    dataItemKey="id"
                                    className="full"
                                    disabled={ true }
                                />
                                </td>
                                <td> NU </td>
                                <td> {investigatie.status} </td>
                                <td> {investigatie.motivRespingere}</td>
                                {
                                    props.statusFinalizare != 1 &&
                                    <>
                                        <td data-name="investigatie_edit" onClick={() => handleClick(index)}>
                                            <span className="icon modifica center"></span>
                                        </td>
                                        <td data-name="investigatie_del" >
                                            <span
                                                className="icon sterge center"
                                                onClick={() => handleDeleteInvestigatie(index)}
                                            ></span>
                                        </td>
                                    </>
                                }
                            </tr>
                        ))}
                    </tbody>

                </table>
                {
                    props.statusFinalizare != 1 &&
                    
                        (<button data-name="adauga_investigatie" className="btn mt10" onClick={handleAddInvestigatie}>
                            Adauga investigatie
                        </button>)
                    
                    
                    
                }
                <button data-name="admin_investig" className="btn mt10" onClick={showInvestigatiiPacient}>Investigatii pacient</button>
            </fieldset>


            {
                showDialog && activeDialog =="investigatii" && < ListDialog title="Investigatii"
                    data={dropdown}
                    handleDialog={handleDialog}
                    handleReturn={handleReturn} />
            }

            {
                showDialog && activeDialog =="investigatii-pacient" &&< ConsultationPatientInvestigations
                handleDialog={handleDialog}
                handleReturn={handleReturn}
                params = {props.param}
            />
            }
        </>

    );
}